var render = function render(){var _vm=this,_c=_vm._self._c;return _c('permissions-checkbox',_vm._b({model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},'permissions-checkbox',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }